import { makeStyles } from '@material-ui/core';

const TABLE_HEADER_BACKGROUND = '#EEF3FF';

export default makeStyles(theme => ({
  searchBarOuterWrapper: {
    width: '100%',
    minWidth: 0,
    marginBottom: theme.spacing(2),
    boxSizing: 'border-box',
  },
  searchBarRow: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    minWidth: 0,
  },
  searchInputCell: {
    flex: '1 1 0',
    minWidth: 0,
    overflow: 'hidden',
  },
  searchExportCell: {
    flexShrink: 0,
  },
  exportCsvButton: {
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall`]: {
      alignItems: 'center',
      borderWidth: 1,
      boxSizing: 'border-box',
      display: 'inline-flex',
      height: 40,
      justifyContent: 'center',
      maxHeight: 40,
      minHeight: 40,
      padding: theme.spacing(0, 1.75),
    },
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall:hover`]: {
      borderWidth: 1,
      padding: theme.spacing(0, 1.75),
    },
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall:focus`]: {
      borderWidth: 1,
      padding: theme.spacing(0, 1.75),
    },
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall:active`]: {
      borderWidth: 1,
      padding: theme.spacing(0, 1.75),
    },
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall.Mui-focusVisible`]: {
      borderWidth: 1,
      padding: theme.spacing(0, 1.75),
    },
    [`&.MuiButton-root.MuiButton-outlined.MuiButton-sizeSmall.Mui-disabled`]: {
      borderWidth: 1,
      padding: theme.spacing(0, 1.75),
    },
  },
  searchAdornmentCell: {
    flexShrink: 0,
  },
  tableScrollWrapper: {
    overflowX: 'auto',
    width: '100%',
    '& table': {
      minWidth: 0,
    },
    // Sticky: last column = filter (header) + 3 dots (rows) in one column
    '& table th:nth-last-child(1), & table td:nth-last-child(1)': {
      position: 'sticky',
      right: 0,
      zIndex: 2,
      minWidth: 56,
      padding: theme.spacing(1, 0.5),
      boxShadow: '-4px 0 8px rgba(0,0,0,0.06)',
      verticalAlign: 'middle',
    },
    '& table thead th:nth-last-child(1)': {
      background: TABLE_HEADER_BACKGROUND,
      borderTopRightRadius: 8,
      boxShadow: '-4px 0 8px rgba(16, 24, 40, 0.06)',
    },
    '& table tbody td:nth-last-child(1)': {
      background: theme.palette.common.white,
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 8,
        background: 'linear-gradient(to right, rgba(0, 0, 0, 0.06), transparent)',
        pointerEvents: 'none',
        zIndex: 0,
      },
      '& > span': {
        position: 'relative',
        zIndex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  },
  statusCell: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    whiteSpace: 'nowrap',
  },
  statusIcon: {
    fontSize: '1.2rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inactiveIcon: {
    color: theme.palette.grey[500],
  },
  criticalityLowIcon: {
    color: theme.palette.info.main,
  },
  criticalityMediumIcon: {
    color: theme.palette.warning.main,
  },
  criticalityHighIcon: {
    color: theme.palette.error.main,
  },
}));
